import type { Source } from '../types/dashboard';

export const CHART = {
  navy: '#14305C',
  digital: '#2F6DB5',
  local: '#9CC0E6',
  unknown: '#C3CBD6',
  accent: '#E8692A',
  grid: '#E8ECF1',
  axis: '#5A6A80',
  muted: '#8593A6',
};

export const AOP_PALETTE = ['#2F6DB5', '#E8692A', '#3F8F6B', '#7A5AC8'];

/** Acquisition-source groups (illustrative mapping of member referrer values). */
export const SOURCE_META: { key: Source; label: string; color: string }[] = [
  { key: 'Digital', label: 'Digital', color: CHART.digital },
  { key: 'Local', label: 'Local / Other', color: CHART.local },
  { key: 'Unknown', label: 'Unknown / Unclassified', color: CHART.unknown },
];

export const sourceLabel = (s: Source) => SOURCE_META.find((x) => x.key === s)?.label ?? s;
